import { SynthScene } from './synth-scene.js';
import { SynthGUI } from './gui/synth-gui.js';
import { synthConfig } from './config/scene-config.js';
import { logVersion } from './utils/version.js';

// Wyświetl wersję w konsoli
logVersion();

// Inicjalizacja sceny
let synthScene = null;
let synthGUI = null;

/**
 * Inicjalizacja sceny synth
 */
async function initSynthScene() {
    const container = document.body;
    synthScene = new SynthScene(container, synthConfig);
    
    if (await synthScene.init()) {
        console.log('Synth scene initialized');
        window.__synthScene = synthScene;
        synthGUI = new SynthGUI(synthScene, synthConfig);
        synthGUI.init();
    } else {
        console.warn('Failed to initialize synth scene');
    }
}

// Inicjalizacja po załadowaniu DOM
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSynthScene);
} else {
    initSynthScene();
}

// Export dla możliwości aktualizacji konfiguracji z zewnątrz
export { synthScene, synthConfig };
